import { Api } from "../../../../api/land/Api";
import StaType1 from "../subComponents/type1/StaType1";

const allOptions = [
  {
    type: "type1",
    label: "每筆土地各地號的土地權利、標示事件變更次數",
    apiStr: Api.getStsType1(),
    component: StaType1,
  },
];

export default allOptions;
